import { Type } from 'class-transformer';
import {
  IsArray,
  IsBoolean,
  IsIn,
  IsInt,
  IsNumber,
  IsOptional,
  IsString,
  IsUUID,
  Min,
  ValidateNested,
} from 'class-validator';
import { FIELD_VALUE_SOURCES, type FieldValueSource } from '../../label/field-value-source';
import { ADDITIVE_FUNCTIONS, type AdditiveFunction } from './additive-function.enum';
import { LinkedIngredientSummaryDto } from './linked-ingredient-summary.dto';

export class IngredientComponentResponseDto {
  @IsUUID()
  id!: string;

  @IsString()
  name!: string;

  @IsInt()
  @Min(0)
  sortOrder!: number;

  /** Presente solo sulle righe linkate; allergeni e additivi propri sono allora vuoti. */
  @IsOptional()
  @IsUUID()
  linkedIngredientId?: string | null;

  @IsOptional()
  @ValidateNested()
  @Type(() => LinkedIngredientSummaryDto)
  linkedIngredient?: LinkedIngredientSummaryDto | null;

  @IsOptional()
  @IsUUID()
  allergenId?: string | null;

  @IsOptional()
  @IsUUID()
  substanceId?: string | null;

  @IsOptional()
  @IsIn(ADDITIVE_FUNCTIONS)
  additiveFunction?: AdditiveFunction | null;

  @IsOptional()
  @IsString()
  additiveENumber?: string | null;

  @IsBoolean()
  isCarryOverExempt!: boolean;

  @IsIn(FIELD_VALUE_SOURCES)
  source!: FieldValueSource;

  /** Percentuale dichiarata dal fornitore, riferita alla voce madre. */
  @IsOptional()
  @IsNumber()
  declaredPercent?: number | null;

  /** Sotto-voci inline (solo righe semplici), in `sortOrder`. Vuoto se nessuna. */
  @IsOptional()
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => IngredientComponentResponseDto)
  children?: IngredientComponentResponseDto[];
}
